module.exports = __webpack_public_path__ + "img/fontawesome-webfont.f775f9cc.svg";